// @flow
import * as React from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { MuiThemeProvider } from '@material-ui/core';
import Print from '@material-ui/icons/Print';

import type { MessageType } from 'common/components/PageMessage';
import PageMessage from 'common/components/PageMessage';
import IconButton from 'common/components/ui/IconButton';
import { MuiTheme, Stylesheet } from 'statsradio/themes/v3';
import LoadingSpinner from 'common/components/LoadingSpinner';

const PrintIcon = styled(Print)`
  width: 36px;
  height: 36px;
`;

const ContentWrapper = styled(Stylesheet)`
  position: relative;
  width: 100%;
  background-color: ${props => props.theme.V3.colors.background};
`;

const StyledContainer = styled.section`
  height: 100%;
  overflow: hidden;

  min-height: calc(100vh - ${props => props.theme.V3.metrics.navbar.height}px);
  display: flex;
  align-items: center;
  flex-direction: column;

  padding: ${props => props.theme.V3.metrics.page.y}px ${props => props.theme.V3.metrics.page.x}px;

  @media only screen and (max-width: ${props => props.theme.V3.metrics.breakpoints.small}) {
    padding-bottom: ${props => props.theme.V3.metrics.margin.normal}px;
  }
`;

const PageWrapper = styled.section`
  width: 100%;

  max-width: 100%;

  @media only screen and (max-width: ${props => props.theme.V3.metrics.breakpoints.small}) {
    max-width: 100%;
  }
`;

const LoadingWrapper = styled.div`
  display: flex;
  min-height: 500px;

  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
`;

const Header = styled.header`
  text-align: left;
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media only screen and (max-width: ${props => props.theme.V3.metrics.breakpoints.small}) {
    max-width: 100%;
  }
`;

const HeaderRightActionsContainer = styled.aside`
  display: flex;
  align-items: center;
`;

type Message = {
  message: any;
  type: MessageType;
}

type Props = {
  children: any;
  messages?: Message[];
  onPrint?: () => void;
  title: string;

  extraRightAction?: React.Node;
  helmetTitle?: string;
  isLoading?: boolean;
};

export default function Page({ children, extraRightAction, helmetTitle, messages, isLoading, onPrint, title }: Props) {
  return (
    <MuiThemeProvider theme={MuiTheme}>
      <ContentWrapper>
        {(messages || []).map(({ message, type }) =>
          <PageMessage key={message + type} message={message} type={type} />)
        }
        <StyledContainer>
          <Helmet>
            <title>{helmetTitle || title}</title>
          </Helmet>

          <Header>
            <h1>{title}</h1>
            <HeaderRightActionsContainer>
              { extraRightAction }
              { !isLoading && onPrint &&
                <IconButton onClick={onPrint}>
                  <PrintIcon />
                </IconButton>
              }
            </HeaderRightActionsContainer>
          </Header>

          <PageWrapper>
            {isLoading &&
              <LoadingWrapper>
                <LoadingSpinner size="large" />
              </LoadingWrapper>
            }
            {!isLoading && children}
          </PageWrapper>
        </StyledContainer>
      </ContentWrapper>
    </MuiThemeProvider>
  );
}



// WEBPACK FOOTER //
// ./src/statsradio/components/page/v2/Page.js